import React from 'react'
import usePromotionsDetails from '../hooks/usePromotionsDetails'
import Preloader from '../../../../components/Preloader'
import CreatePromotionsNew from './CreatePromotionsNew'

const EditPromotions = () => {
  const { promotionPageData } = usePromotionsDetails()
  console.log('hello promotionPageData',promotionPageData);

  return (
          <CreatePromotionsNew promotionsData={promotionPageData} />
        )
}

export default EditPromotions
